import React from "react";

interface LocationInputIconProps {
  className?: string;
}

const LocationInputIcon = ({ className }: LocationInputIconProps) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M11 14.6667C13.025 14.6667 14.6667 13.025 14.6667 11C14.6667 8.975 13.025 7.33333 11 7.33333C8.975 7.33333 7.33333 8.975 7.33333 11C7.33333 13.025 8.975 14.6667 11 14.6667Z"
      stroke="var(--gray-800)"
      strokeWidth="1.8"
    />
    <path
      d="M11 1.83337V4.58337M11 17.4167V20.1667M20.1667 11H17.4167M4.58333 11H1.83333"
      stroke="var(--gray-800)"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

export default LocationInputIcon;
